import { APPOINTMENT_ACTION, BOOKING_ACTION } from "../actions";

const INITIAL_STATE = {};

const updateAppointmentDetail = (state, action) => {
  const { name, value } = action.payload;
  return { ...state, [name]: value };
};

const resetAppointmentDetail = (state, action) => {
  const { appointment } = action.payload;
  return appointment;
};

export const appointmentReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case APPOINTMENT_ACTION.UPDATE_APPOINTMENT_DETAIL:
      return updateAppointmentDetail(state, action);

    case BOOKING_ACTION.GO_BACK_TO_STEP:
      return resetAppointmentDetail(state, action);

    case BOOKING_ACTION.MAKE_NEW_BOOKING:
      return INITIAL_STATE;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/reducers/appointmentReducer.js